/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogType, DialogFooter } from '@bingads-webui-react/fabric-control';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withScope } from '@bingads-webui-react/scope-service';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { PrimaryButton } from '@bingads-webui-react/fabric-with-signal';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';

import {
  withSiteMap,
  processor,
  siteMapPropType,
  findAllSiteMap,
} from '@bingads-webui-react/with-site-map';
import { withHotKeys } from './hot-keys';
import { shortcutStyles } from './style/styles';
import { ShortcutType, ShortcutTypeKeyMapping } from './shortcut-list';

const macKey = '\u2318';
class HotKeyDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showDialog: false };
    this.isOSMac = window.navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    this.HotKeyString = _TL_('Go to {{whichPage}}');
  }

  shouldComponentUpdate(nextProps, nextState) {
    const currentShow = this.state.showDialog;
    if (nextState.showDialog !== this.state.showDialog) {
      return true;
    } else if (nextProps.hotKey === ShortcutTypeKeyMapping[ShortcutType.ShowHideShortcutDialog] && nextProps.count !== this.props.count) {
      this.setState({
        showDialog: !currentShow,
      });
      return true;
    }
    return false;
  }

  dismissDialog = () => {
    this.setState({
      showDialog: false,
    });
  };

  render() {
    const {
      i18n,
      classes,
      siteMap,
      permissions,
    } = this.props;
    const siteMapItems = findAllSiteMap(siteMap, item => item.shortcut);
    const IsRenameHotelToLodgingEnabled = permissions && permissions.dynamic && permissions.dynamic.IsRenameHotelToLodgingEnabled;
    const isNavRefresh = isNavigationRefreshOn(permissions);

    return (
      <Dialog
        hidden={!this.state.showDialog}
        onDismiss={this.dismissDialog}
        className={classes.shortcutDialogStyle}
        dialogContentProps={{
          type: DialogType.close, // with x close button in the upper-right corner
          title: i18n.getString(_TL_('Keyboard shortcuts')),
        }}
        maxWidth={760}
        minWidth={560}
        modalProps={{
          isBlocking: true,
          dragOptions: undefined,
          layerProps: {
            // otherwise event willbe stopped by layer and will not caught by document used in react-hot-keys
            eventBubblingEnabled: true,
          },
        }}
      >
        <div className="shortcutContent">
          <div className="shortcutItems left" >
            <div className="shortcutItem">
              <div className="shortcutKey item longItem">Shift</div>
              <div className="item">+</div>
              <div className="shortcutKey item">?</div>
              <div className="shortcutNavigation item">{i18n.getString(_TL_('Show or hide shortcuts list'))}</div>
            </div>
            {siteMapItems.map(item => (
              <div className="shortcutItem" key={`shortcut-item-${item.id}`}>
                <div className="shortcutKey item">{item.shortcut.split('+')[0].toUpperCase()}</div>
                <div className="item">+</div>
                <div className="shortcutKey item">{item.shortcut.split('+')[1].toUpperCase()}</div>
                <div className="shortcutNavigation item">{i18n.getString(this.HotKeyString, { whichPage: i18n.getString(item.name) })}</div>
              </div>))}
            <div className="shortcutItem">
              <div className="shortcutKey item longItem">Shift</div>
              <div className="item">+</div>
              <div className="shortcutKey item">N</div>
              <div className="shortcutNavigation item">{i18n.getString(_TL_('Create New'))}</div>
            </div>
          </div>
          <div className="shortcutItems right" >
            <div className="shortcutItem">
              <div className="shortcutKey item">Shift</div>
              <div className="item">+</div>
              <div className="shortcutKey item">W</div>
              <div className="shortcutNavigation item">{isNavRefresh ? i18n.getString(_TL_('Show or hide secondary navigation')) : i18n.getString(_TL_('Show or hide main menu'))}</div>
            </div>
            <div className="shortcutItem">
              <div className="shortcutKey item">Shift</div>
              <div className="item">+</div>
              <div className="shortcutKey item">H</div>
              <div className="shortcutNavigation item">{i18n.getString(_TL_('Show or hide help menu'))}</div>
            </div>
            <div className="shortcutItem">
              <div className="shortcutKey item">Shift</div>
              <div className="item">+</div>
              <div className="shortcutKey item">A</div>
              <div className="shortcutNavigation item">{i18n.getString(_TL_('See All campaigns'))}</div>
            </div>
            <div className="shortcutItem">
              <div className="shortcutKey item">Shift</div>
              <div className="item">+</div>
              <div className="shortcutKey item">S</div>
              <div className="shortcutNavigation item">{i18n.getString(_TL_('See Search campaigns'))}</div>
            </div>
            <div className="shortcutItem">
              <div className="shortcutKey item">Shift</div>
              <div className="item">+</div>
              <div className="shortcutKey item">P</div>
              <div className="shortcutNavigation item">{i18n.getString(_TL_('See Shopping campaigns'))}</div>
            </div>
            <div className="shortcutItem">
              <div className="shortcutKey item">Shift</div>
              <div className="item">+</div>
              <div className="shortcutKey item">D</div>
              <div className="shortcutNavigation item">{i18n.getString(_TL_('See Audience campaigns'))}</div>
            </div>
            <div className="shortcutItem">
              <div className="shortcutKey item">Shift</div>
              <div className="item">+</div>
              <div className="shortcutKey item">T</div>
              <div className="shortcutNavigation item">{i18n.getString(_TL_('See Smart campaigns'))}</div>
            </div>
            <div className="shortcutItem">
              <div className="shortcutKey item">Shift</div>
              <div className="item">+</div>
              <div className="shortcutKey item">L</div>
              <div className="shortcutNavigation item">{ IsRenameHotelToLodgingEnabled ? i18n.getString(_TL_('See Lodging campaigns')) : i18n.getString(_TL_('See Hotel campaigns'))}</div>
            </div>
            <div className="shortcutItem">
              {
                this.isOSMac ? <div className="shortcutKey item shortItem">{macKey}</div>
                : <div className="shortcutKey item">Ctrl</div>
              }
              <div className="item">+</div>
              <div className="shortcutKey item">C</div>
              <div className="shortcutNavigation item">{i18n.getString(_TL_('Copy'))}</div>
            </div>
            <div className="shortcutItem">
              {
                this.isOSMac ? <div className="shortcutKey item shortItem">{macKey}</div>
                : <div className="shortcutKey item">Ctrl</div>
              }
              <div className="item">+</div>
              <div className="shortcutKey item">V</div>
              <div className="shortcutNavigation item">{i18n.getString(_TL_('Paste'))}</div>
            </div>
          </div>
        </div>
        <DialogFooter>
          <PrimaryButton
            className="closeButton"
            onClick={this.dismissDialog}
            text={i18n.getString(_TL_('Close'))}
          />
        </DialogFooter>
      </Dialog>
    );
  }
}

HotKeyDialog.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  siteMap: siteMapPropType.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
  hotKey: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      IsRenameHotelToLodgingEnabled: PropTypes.bool,
    }),
  }),
};

HotKeyDialog.defaultProps = {
  permissions: {
    dynamic: {},
  },
};
export const HotKeyDialogWithI18n =
withPermissions(withSiteMap(
  withScope(withInstrumentation(withHotKeys(withI18nConsumer(withDefaultStyles(HotKeyDialog, shortcutStyles)), ShortcutType.ShowHideShortcutDialog))),
  [processor.processPermissions, processor.processPath, processor.processScope]
));
